// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class AllBanksEscalatorsUseResponse implements flatbuffers.IUnpackableObject<AllBanksEscalatorsUseResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AllBanksEscalatorsUseResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAllBanksEscalatorsUseResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksEscalatorsUseResponse,
  ): AllBanksEscalatorsUseResponse {
    return (obj || new AllBanksEscalatorsUseResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAllBanksEscalatorsUseResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksEscalatorsUseResponse,
  ): AllBanksEscalatorsUseResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AllBanksEscalatorsUseResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankName(): string | null;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bankName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  liftName(): string | null;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  liftName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  availability(): string;
  availability(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  availability(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  serviceMode(): string;
  serviceMode(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  serviceMode(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  bankId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startAllBanksEscalatorsUseResponse(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankNameOffset, 0);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftNameOffset, 0);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, dateOffset, 0);
  }

  static addAvailability(builder: flatbuffers.Builder, availabilityOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, availabilityOffset, 0);
  }

  static addServiceMode(builder: flatbuffers.Builder, serviceModeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, serviceModeOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankId: number) {
    builder.addFieldInt16(5, bankId, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(6, liftId, 0);
  }

  static endAllBanksEscalatorsUseResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 8); // date
    builder.requiredField(offset, 10); // availability
    builder.requiredField(offset, 12); // service_mode
    return offset;
  }

  static createAllBanksEscalatorsUseResponse(
    builder: flatbuffers.Builder,
    bankNameOffset: flatbuffers.Offset,
    liftNameOffset: flatbuffers.Offset,
    dateOffset: flatbuffers.Offset,
    availabilityOffset: flatbuffers.Offset,
    serviceModeOffset: flatbuffers.Offset,
    bankId: number,
    liftId: number,
  ): flatbuffers.Offset {
    AllBanksEscalatorsUseResponse.startAllBanksEscalatorsUseResponse(builder);
    AllBanksEscalatorsUseResponse.addBankName(builder, bankNameOffset);
    AllBanksEscalatorsUseResponse.addLiftName(builder, liftNameOffset);
    AllBanksEscalatorsUseResponse.addDate(builder, dateOffset);
    AllBanksEscalatorsUseResponse.addAvailability(builder, availabilityOffset);
    AllBanksEscalatorsUseResponse.addServiceMode(builder, serviceModeOffset);
    AllBanksEscalatorsUseResponse.addBankId(builder, bankId);
    AllBanksEscalatorsUseResponse.addLiftId(builder, liftId);
    return AllBanksEscalatorsUseResponse.endAllBanksEscalatorsUseResponse(builder);
  }

  unpack(): AllBanksEscalatorsUseResponseT {
    return new AllBanksEscalatorsUseResponseT(
      this.bankName(),
      this.liftName(),
      this.date(),
      this.availability(),
      this.serviceMode(),
      this.bankId(),
      this.liftId(),
    );
  }

  unpackTo(_o: AllBanksEscalatorsUseResponseT): void {
    _o.bankName = this.bankName();
    _o.liftName = this.liftName();
    _o.date = this.date();
    _o.availability = this.availability();
    _o.serviceMode = this.serviceMode();
    _o.bankId = this.bankId();
    _o.liftId = this.liftId();
  }

  unpackFields(...fields: string[]): AllBanksEscalatorsUseResponseT {
    const t = new AllBanksEscalatorsUseResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("availability")) {
      t.availability = this.availability();
    }
    if (fieldSet.has("service_mode")) {
      t.serviceMode = this.serviceMode();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    return t;
  }
}

export class AllBanksEscalatorsUseResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankName: string | Uint8Array | null = null,
    public liftName: string | Uint8Array | null = null,
    public date: string | Uint8Array | null = null,
    public availability: string | Uint8Array | null = null,
    public serviceMode: string | Uint8Array | null = null,
    public bankId: number = 0,
    public liftId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    if (this.availability === null || this.availability === undefined) {
      throw new Error('Required field "availability" is not set');
    }
    if (this.serviceMode === null || this.serviceMode === undefined) {
      throw new Error('Required field "service_mode" is not set');
    }
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const availability = this.availability !== null ? builder.createString(this.availability!) : 0;
    const serviceMode = this.serviceMode !== null ? builder.createString(this.serviceMode!) : 0;

    return AllBanksEscalatorsUseResponse.createAllBanksEscalatorsUseResponse(
      builder,
      bankName,
      liftName,
      date,
      availability,
      serviceMode,
      this.bankId,
      this.liftId,
    );
  }

  clone(): AllBanksEscalatorsUseResponseT {
    const obj = new AllBanksEscalatorsUseResponseT();
    obj.bankName = this.bankName;
    obj.liftName = this.liftName;
    obj.date = this.date;
    obj.availability = this.availability;
    obj.serviceMode = this.serviceMode;
    obj.bankId = this.bankId;
    obj.liftId = this.liftId;
    return obj;
  }

  equals(other: AllBanksEscalatorsUseResponseT): boolean {
    if (this.bankName !== other.bankName) return false;
    if (this.liftName !== other.liftName) return false;
    if (this.date !== other.date) return false;
    if (this.availability !== other.availability) return false;
    if (this.serviceMode !== other.serviceMode) return false;
    if (this.bankId !== other.bankId) return false;
    if (this.liftId !== other.liftId) return false;
    return true;
  }
}

export function verifyAllBanksEscalatorsUseResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "availability");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "service_mode");
    verifier.checkScalarField(tablePos, 14, 2);
    verifier.checkScalarField(tablePos, 16, 2);
  } finally {
    verifier.popDepth();
  }
}
